export const getActions = (set, get) => ({
    updateState: state => {
        set(state);
    },
    getLogo: () => {
        var _a;
        return (_a = get().logo) !== null && _a !== void 0 ? _a : undefined;
    },
});
